import { render, staticRenderFns } from "./groupon_invite_postcard.vue?vue&type=template&id=4863501d&scoped=true&"
import script from "./groupon_invite_postcard.vue?vue&type=script&lang=js&"
export * from "./groupon_invite_postcard.vue?vue&type=script&lang=js&"
import style0 from "./groupon_invite_postcard.vue?vue&type=style&index=0&id=4863501d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4863501d",
  null
  
)

export default component.exports